interface SvgBookmarkAddProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}
export default function SvgBookmarkAdd(props: SvgBookmarkAddProps) {
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}><path d="M13.5 1.5V3H6V20.0605L11.3242 17.3711L12 17.0293L12.6777 17.3711L18 20.0635V12H19.5V22.5L12 18.71L4.5 22.5V3C4.5 2.60218 4.65815 2.22076 4.93945 1.93945C5.22076 1.65815 5.60218 1.5 6 1.5H13.5ZM19.5 1.5V4.5H22.5V6H19.5V9H18V6H15V4.5H18V1.5H19.5Z" fill="currentColor" /></svg>;
}